export default __webpack_public_path__ + "static/media/twitter-1442879700049612800.cf501ed3.jpg";